import React, { Component, FormEvent, FormHTMLAttributes } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

export interface IFormProps {
    onSubmit: () => Promise<void> | void;
    onLoading?: (loading: boolean) => void;
}

export type FormProps = IFormProps & FormHTMLAttributes<HTMLElement>;

@observer
export class Form extends Component<FormProps> {
    @observable
    private loading: boolean = false;

    public render() {
        const { onSubmit } = this;
        const { children, onSubmit: _1, onLoading: _2, ...props } = this.props;
        return (
            <form onSubmit={onSubmit} {...props}>
                {children}
            </form>
        );
    }

    private onSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { loading } = this;
        const { onSubmit } = this.props;
        if (!loading) {
            this.setLoading(true);
            try {
                await onSubmit();
            } finally {
                this.setLoading(false);
            }
        }
    };

    private setLoading(loading: boolean) {
        this.loading = loading;
        const { onLoading } = this.props;
        if (onLoading) {
            onLoading(loading);
        }
    }
}
